// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";

import App from "./App";

import store from "./store";
import router from "./router";
import "./registerServiceWorker";

//import "@babel/polyfill";

import searchParams from "url-search-params-polyfill";
Vue.use(searchParams);

// Plugins init
import { VLazyImagePlugin } from "v-lazy-image";
Vue.use(VLazyImagePlugin);

import popup from "./plugins/popup";
Vue.use(popup);

import overlay from "./plugins/overlay";
Vue.use(overlay);
Vue.prototype.$overlay({
  loading_img: "img/loader.svg",
  color: "#ffbb0ccf",
  closable: true
});

Vue.config.productionTip = false;

import Searcher from "@/components/ui/Searcher";
import LangSelector from "@/components/ui/LangSelector";
Vue.component("Searcher", Searcher);
Vue.component("LangSelector", LangSelector);

import Default from "./layouts/Default-Layout.vue";
import Login from "./layouts/Login-Layout.vue";
import Admin from "./layouts/Admin-Layout.vue";
import Partner from "./layouts/Partner-Layout.vue";

Vue.component("default-layout", Default);
Vue.component("login-layout", Login);
Vue.component("admin-layout", Admin);
Vue.component("partner-layout", Partner);

import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

import VuejsClipper from "vuejs-clipper";
Vue.use(VuejsClipper);

import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);

Vue.component("apexchart", VueApexCharts);

// import '@/../public/css/custom_vuetify.scss';

import cssVars from "css-vars-ponyfill";
cssVars({
  variables: {
    main_color: "#FFBB0C",
    secondary_color: "#004412",
    dark_color: "#222222"
  }
});
import i18n from "./i18n";

/* eslint-disable no-new */
new Vue({
  el: "#app",
  store,
  router,
  i18n,
  components: { App },
  template: "<App/>"
  /*mounted() {
    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', '~@/core/store.js')
    document.head.appendChild(recaptchaScript)
  },*/
});

// Shared variables

//var menu_is_visible = true;
